export default "__VITE_ASSET__C99FnmY2__"